export default {
    /**
     * 元素的属性集合转换为对象
     * @param attributeSet
     */
    attributeSet2Object(attributeSet: any) {
        const obj: any = {};
        for (let i = 0; i < attributeSet.getCount(); i++ ) {
            const attribute = attributeSet.getItem(i);
            obj[attribute.name] = attribute.value;
        }
        return obj;
    },
};

